import _isFinite2 from "lodash/isFinite";
import _useMediaQuery from "@material-ui/core/esm/useMediaQuery";
import React from 'react';
import classnames from 'classnames';
import { getLeftTime } from 'swag-common/utils/date-lib';
import { Button } from 'swag-client-common/components/ui/button';
import { ProductionTimeBlock } from '../production-time-block';
import classes from './footer.scss';
export function Footer({
  addToCartEnabled,
  onShowWarning,
  PriceBlock,
  buttonLabel = 'Add to Cart',
  clickAddToCart,
  isOutOfStock,
  isLimitedEdition,
  expirationDateForLimitedEdition,
  totalOfAssociatedPrice,
  isAdminLoggedInMode
}) {
  const isTabletOrSmallLaptopScreen = _useMediaQuery('(min-width: 769px) and (max-width: 1469px)');
  const isFittingAssociatedPrice = _useMediaQuery('(min-width: 769px) and (max-width: 1920px)');
  const onClickHandler = e => {
    if (isLimitedEdition && getLeftTime(expirationDateForLimitedEdition) === 0) {
      return onShowWarning(e);
    }
    clickAddToCart();
    if (!addToCartEnabled) {
      onShowWarning(e);
    }
  };
  const isShowingRelatedPrice = _isFinite2(totalOfAssociatedPrice);
  const shouldShrinkInfoForRelatedProducts = isShowingRelatedPrice && isFittingAssociatedPrice;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.footer, {
      [classes.isDisabled]: isOutOfStock,
      [classes.liftedFooter]: isAdminLoggedInMode
    })
  }, isTabletOrSmallLaptopScreen ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.info
  }, /*#__PURE__*/React.createElement(ProductionTimeBlock, {
    rowClassName: classes.infoRow,
    labelClassName: classes.infoLabel,
    isLimitedEdition: isLimitedEdition,
    valueClassName: classes.infoValue,
    wrapperClassName: classes.infoWrapper
  }), /*#__PURE__*/React.createElement(PriceBlock, {
    labelClassName: classes.infoLabel,
    rowClassName: classes.infoRow,
    valueClassName: classes.infoValue
  })), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.rowMobile)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClickHandler,
    type: "submit",
    className: classnames(classes.submit, {
      [classes.limitedEdition]: isLimitedEdition
    }),
    withFocusOutline: true
  }, buttonLabel))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProductionTimeBlock, {
    shouldShowProductionTimeLabel: !shouldShrinkInfoForRelatedProducts,
    isLimitedEdition: isLimitedEdition
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSection
  }, /*#__PURE__*/React.createElement(PriceBlock, {
    labelClassName: isShowingRelatedPrice ? classes.labelColumn : undefined,
    rowClassName: isShowingRelatedPrice ? classes.associatedRow : undefined
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.rowMobile)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClickHandler,
    type: "submit",
    className: classnames(classes.submit, {
      [classes.limitedEdition]: isLimitedEdition
    }),
    withFocusOutline: true
  }, buttonLabel)))));
}